export default __webpack_public_path__ + "static/media/attachment.ff2238e7.svg";